import Dexie, { type Table } from 'dexie';

export interface TTSMuteRecord {
  workspaceId: string;
  userProfileId: string;
  muted: boolean;
}

export class TTSDatabase extends Dexie {
  ttsMutes!: Table<TTSMuteRecord, [string, string]>;

  constructor() {
    super('BloomstackTTS');

    this.version(1).stores({
      ttsMutes: '[workspaceId+userProfileId]',
    });
  }
}

export const ttsDb = new TTSDatabase();

export async function setTTSMuted(
  workspaceId: string,
  userProfileId: string,
  muted: boolean,
): Promise<void> {
  await ttsDb.ttsMutes.put({ workspaceId, userProfileId, muted });
}
